import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ShopRating = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${layout.spacing.xSmall};
  font-size: 16px;
  font-weight: 600;

  svg {
    margin-right: ${layout.spacing.xSmall};
  }
`;
